import { CanDeactivateFn } from '@angular/router';

export interface HasUnsavedChanges {
    hasUnsavedChanges(): boolean;
    showUnsavedDialog(): Promise<boolean>;
}

export const unsavedChangesGuard: CanDeactivateFn<HasUnsavedChanges> = async (component) => {
    if (component.hasUnsavedChanges()) {
        return component.showUnsavedDialog();
    }
    return true;
};
